<div class="container">
  <ng-container
    *ngIf="timePeriod; then timePeriodInput; else timeSliceInput"
  ></ng-container>
  <div class="controls">
    <div class="up" (click)="changeValue('up')">
      <svg width="13px" height="7px">
        <path
          fill-rule="evenodd"
          fill="rgb(135, 155, 175)"
          d="M1.047,0.499 L-0.003,1.547 L4.999,6.539 L10.001,1.547 L8.950,0.499 L4.999,4.442 L1.047,0.499 Z"
        />
      </svg>
    </div>
    <div class="down" (click)="changeValue('down')">
      <svg width="13px" height="7px">
        <path
          fill-rule="evenodd"
          fill="rgb(135, 155, 175)"
          d="M1.047,0.499 L-0.003,1.547 L4.999,6.539 L10.001,1.547 L8.950,0.499 L4.999,4.442 L1.047,0.499 Z"
        />
      </svg>
    </div>
  </div>
</div>

<ng-template #timeSliceInput>
  <input
    *ngIf="isHour"
    [attr.value]="timeSlice"
    type="number"
    min="0"
    max="23"
    (input)="onChange($any($event.target).value)"
  />
  <input
    *ngIf="!isHour"
    [attr.value]="timeSlice"
    type="number"
    min="0"
    max="59"
    (input)="onChange($any($event.target).value)"
  />
</ng-template>
<ng-template #timePeriodInput>
  <input type="text" [attr.value]="timePeriod" readonly />
</ng-template>
